// const devConfigs = {
//     apiUrl: 'https://email-api-dev.a4apple.cn:51127/',
//     memberShipApi: "https://membership-api-uat.gima.app/member-group-data/list?companycode=HKBA&environment=dev",
//     dmsApiURL: "https://dms-api-dev.a4apple.cn:51127/",
//     apiFileUrl: 'https://email-api-dev.a4apple.cn:51127/files/',
//     baseUrl: 'https://email-api-dev.a4apple.cn:51127/',
//     dmsURL: "https://dms-dev.a4apple.cn:51127/",
//     dmsDownloadAPI: "https://dms-api-dev.a4apple.cn:51127/files/DownLoadFiles",
//     mailMergeApi: "https://merge-api-dev.a4apple.cn:51127/",
//     mailServerAPI: "https://email-api-dev.a4apple.cn:51127",
//     applicationListAPI: `https://siia-sso-api-dev.a4apple.cn:63603/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`, //`https://sso-api-uat.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
//     applicationListPrdAPI: `https://siia-gima-api.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
//     applicationListUATAPI: `https://sso-api-uat.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
//     gimaDevAPI: "https://gima-api-dev.a4apple.cn:51127/api/v3/staff",
//     gimaUatAPI: "https://gima-api-demo.gima.app/api/v3/staff",
//     gimaBasePersonal: `https://gima-dev.a4apple.cn:51127/email/GIMABasepersonal`,
//     REACT_APP_GIMA_THEME_API: "https://gima-api-dev.a4apple.cn:51127/theme/getlist",
//     REACT_APP_NOT_AUTHORIZED_REDIRECTION: "https://gima-dev.a4apple.cn:51127/"
// }

// const uatConfigs = {
//     apiUrl: 'https://mail-api-demo.gima.app/',
//     memberShipApi: "https://membership-api-uat.gima.app/member-group-data/list?companycode=HKBA&environment=dev",
//     dmsApiURL: "https://dms-api-demo.gima.app/",
//     apiFileUrl: 'https://mail-api-demo.gima.app/files/',
//     baseUrl: 'https://mail-api-demo.gima.app/',
//     dmsURL: "https://dms-demo.gima.app/",
//     dmsDownloadAPI: "https://dms-api-demo.gima.app/files/DownLoadFiles",
//     mailMergeApi: "https://merge-api-demo.gima.app/",
//     mailServerAPI: "https://mail-api-demo.gima.app",
//     applicationListAPI: `https://siia-sso-api-dev.a4apple.cn:63603/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`, //`https://sso-api-uat.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
//     applicationListPrdAPI: `https://siia-gima-api.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
//     applicationListUATAPI: `https://gima-api-demo.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
//     gimaDevAPI: "https://gima-api-dev.a4apple.cn:51127/api/v3/staff",
//     gimaUatAPI: "https://gima-api-demo.gima.app/api/v3/staff",
//     gimaBasePersonal: `https://gima-api-demo.gima.app/email/GIMABasepersonal`,
//     REACT_APP_GIMA_THEME_API: "https://gima-api-demo.gima.app/theme/getlist",
//     REACT_APP_NOT_AUTHORIZED_REDIRECTION: "https://demo.gima.app/"
// }

// const prdConfigs = {
//     apiUrl: 'https://api-email.siia.group/',
//     memberShipApi: "https://membership-api.siia.group/member-group-data/list?companycode=HKBA&environment=production",
//     dmsApiURL: "https://api-dms.siia.group/",
//     apiFileUrl: 'https://api-email.siia.group/files/',
//     baseUrl: 'https://api-email.siia.group/',
//     dmsURL: "https://dms.siia.group/",
//     dmsDownloadAPI: "https://api-dms.siia.group/files/DownLoadFiles",
//     mailMergeApi: "https://merge-api.siia.group/",
//     mailServerAPI: "https://api-email.siia.group",
//     applicationListAPI: `https://siia-sso-api-dev.a4apple.cn:63603/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`, //`https://sso-api-uat.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
//     applicationListPrdAPI: `https://siia-gima-api.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
//     applicationListUATAPI: `https://sso-api-uat.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
//     gimaDevAPI: "https://gima-api-dev.a4apple.cn:51127/api/v3/staff",
//     gimaUatAPI: "https://gima-api-demo.gima.app/api/v3/staff",
//     gimaBasePersonal: `https://gima-api-demo.gima.app/email/GIMABasepersonal`,
//     REACT_APP_GIMA_THEME_API: "https://gima-api-demo.gima.app/theme/getlist",
//     REACT_APP_NOT_AUTHORIZED_REDIRECTION: "https://portal.siia.group/"
// }

// export const configs = process.env.REACT_APP_ENV === "PRD" ? prdConfigs : process.env.REACT_APP_ENV === "UAT" ? uatConfigs : devConfigs

export const configs = {
    apiUrl: process.env.REACT_APP_API_URL,
    memberShipApi: process.env.REACT_APP_MEMBERSHIP_URL,
    dmsApiURL: process.env.REACT_APP_DMS_API_URL,
    apiFileUrl: process.env.REACT_APP_API_FILE_URL,
    baseUrl: process.env.REACT_APP_BASE_URL,
    dmsURL: process.env.REACT_APP_DMS_URL,
    dmsDownloadAPI: process.env.REACT_APP_DMS_DOWNLOAD_API,
    mailMergeApi: process.env.REACT_APP_MAIL_MERGE_API,
    mailServerAPI: process.env.REACT_APP_MAIL_SERVER_API,
    applicationListAPI: `${process.env.REACT_APP_APPLICATION_LIST_DEV_API}/${JSON.parse(sessionStorage.getItem('userData'))?.company_code}`,
    applicationListPrdAPI: `${process.env.REACT_APP_APPLICATION_LIST_PRD_API}/${JSON.parse(sessionStorage.getItem('userData'))?.company_code}`,
    applicationListUATAPI: `${process.env.REACT_APP_APPLICATION_LIST_UAT_API}${JSON.parse(sessionStorage.getItem('userData'))?.company_code}`,
    applicationListDemoAPI: `${process.env.REACT_APP_APPLICATION_LIST_DEMO_API}${JSON.parse(sessionStorage.getItem('userData'))?.company_code}`,
    applicationListDrAPI: `${process.env.REACT_APP_APPLICATION_LIST_DR_API}${JSON.parse(sessionStorage.getItem('userData'))?.company_code}`,
    gimaAPI: process.env.REACT_APP_GIMA_API,
    gimaBasePersonal: process.env.REACT_APP_GIMA_BASE_PERSONAL,
    REACT_APP_GIMA_THEME_API: process.env.REACT_APP_GIMA_THEME_API,
    REACT_APP_NOT_AUTHORIZED_REDIRECTION: process.env.REACT_APP_NOT_AUTHORIZED_REDIRECTION
}